import Skeleton from '@/components/ui/Skeleton'
import CourseCardSkeleton from '@/features/courses/components/CourseCardSkeleton'
import {
  CARD_BOX,
  CARD_GRID,
  SEAL_BOX,
} from '@/screens/courses/components/certificates/certificates-box'
import { SHELF_GRID } from '@/screens/courses/components/shelf/shelf-box'
import { cn } from '@/lib/utils'

/**
 * The loaded page's shape: the earned-certificate grid (two cards — a real
 * member's rarely holds more at first), then the "Almost there" shelf (two
 * cards). Light on purpose — `Skeleton` and class strings only — since the
 * route's pending component ships in the entry chunk (docs/route-loading.md).
 */
function CardSkeleton() {
  return (
    <div className={CARD_BOX}>
      <div className="flex items-center gap-4">
        <Skeleton className={cn(SEAL_BOX)} />
        <div className="flex min-w-0 flex-1 flex-col gap-1">
          <div className="flex h-6 items-center">
            <Skeleton className="h-4 w-3/4 rounded-xs" />
          </div>
          <div className="flex h-4 items-center">
            <Skeleton className="h-3 w-32 rounded-xs" />
          </div>
        </div>
      </div>
      <div className="flex flex-wrap items-center justify-between gap-x-4 gap-y-3 border-t border-border-subtle pt-4">
        <div className="flex flex-col gap-1">
          <div className="flex h-4 items-center">
            <Skeleton className="h-3 w-24 rounded-xs" />
          </div>
          <div className="flex h-5 items-center">
            <Skeleton className="h-4 w-40 rounded-xs" />
          </div>
        </div>
        <div className="flex gap-2">
          <Skeleton className="h-11 w-24 rounded-md lg:h-9" />
          <Skeleton className="h-11 w-16 rounded-md lg:h-9" />
        </div>
      </div>
    </div>
  )
}

function ShelfHead({ width }: { width: string }) {
  return (
    <div className="flex min-h-9 items-center">
      <Skeleton className={cn('h-5 rounded-xs', width)} />
    </div>
  )
}

export default function CertificatesSkeleton() {
  return (
    <div aria-hidden="true" className="flex flex-col gap-8">
      <div className="flex flex-col gap-3">
        <ShelfHead width="w-28" />
        <div className={CARD_GRID}>
          <CardSkeleton />
        </div>
      </div>
      <div className="flex flex-col gap-3">
        <ShelfHead width="w-32" />
        <div className={SHELF_GRID}>
          <CourseCardSkeleton />
          <CourseCardSkeleton />
        </div>
      </div>
    </div>
  )
}
